import { GET_ME } from './operations'
import type { TMeQueriesMap } from './types'

export const GRAPHQL_ME_QUERIES: TMeQueriesMap = {
  getMe: GET_ME,
}
